import React from 'react'
import modernWar from "../images/Screen_Massach.png";
import firebase from "../images/firebase.png";
import ufox from "../images/ufox.png";
import beatdata from "../images/BD2022.png";
import uculturemix from "../images/uculturemix.jpg";
import Server from "./component/Server.js";
import MainServer from "./component/MainServer.js";

const Nav = ({serverClicked}) => {

    return(
        <div className="bg-black self-stretch px-5 py-5 flex flex-col items-center w-fit gap-7">
            
            <MainServer serverClicked={serverClicked}/>

            <Server pic={modernWar} altName="modernWar" serverClicked={serverClicked}/>
            <Server pic={firebase} altName="firebase" serverClicked={serverClicked}/>
            <Server pic={ufox} altName="ufox" serverClicked={serverClicked}/>
            <Server pic={beatdata} altName ="beatdata" serverClicked={serverClicked}/>
            <Server pic={uculturemix} altName ="uculturemix" serverClicked={serverClicked}/>

            
        </div>
    )
}

export default Nav